import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id D80E4CB4-F5E6-4BA8-A8C9-B24A3C31E56F
 * name folder-text-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-text-outline.svg
 * tags
 * - Files / Folders 
 */
export const FolderTextOutlineIcon = createSvgIcon(<><path d="M20,18H4V8H20M20,6H12L10,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8A2,2 0 0,0 20,6M15,16H6V14H15V16M18,12H6V10H18V12Z" /></>, 'FolderTextOutlineIcon');
export default FolderTextOutlineIcon